import React from "react";
import Scaffold from "../../../widget/layouts/Scaffold";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import ChatLocationActions from "./widget/ChatLocationActions";
import { ChatLocationContextProvider } from "../../../provider/chats/chats/chat_location/ChatLocationContextProvider";
import ChatLocationContent from "./ChatLocationContent";

const ChatLocationScreen = (props: { screenMobileView: boolean }) => {
  return (
    <ChatLocationContextProvider>
      {props.screenMobileView === true ? (
        <Scaffold
          appBarTitle={AppTranslation.text("send_location")}
          appBarAction={<ChatLocationActions />}
          isModal={true}
        >
          <ChatLocationContent />
        </Scaffold>
      ) : (
        <ChatLocationContent />
      )}
    </ChatLocationContextProvider>
  );
};

export default ChatLocationScreen;
//export const routeName: string = "/chat-location";
